export default "__VITE_ASSET__Clt$Cajn__"